import { useQuery } from "@tanstack/react-query";
import { AiInsightsAdoptionAPI } from "../infrastructure/api/AiInsightsAdoption.api";
import { AiInsightsAdoption } from "../domain/types";

const AI_INSIGHTS_ADOPTION_KEY = "ai-insights-adoption";

/**
 * Adoption state of the AI Insights tool for the current therapist.
 *
 * Fails closed: a network/API error resolves to `adopted: false` so the surface
 * renders a locked state rather than crashing or leaking AI panels.
 */
export const useAiInsightsAdoption = (): AiInsightsAdoption => {
    const { data, isLoading } = useQuery({
        queryKey: [AI_INSIGHTS_ADOPTION_KEY],
        queryFn: AiInsightsAdoptionAPI.isAdopted,
        retry: false,
    });

    return { adopted: data === true, loading: isLoading };
};
